export default __webpack_public_path__ + "static/media/ImpulsoLogin.edfcd385.png";